module.exports = __webpack_public_path__ + "img/outline2.7d262b8c.svg";